import React from "react";
import Management from "../_components/UserManagement/Management";

function UserManagement() {
    return <Management />
}

export default UserManagement;